import { QueryCache, QueryClient } from '@tanstack/react-query';
import { createRouter } from '@tanstack/react-router';

import { RouteError } from './components/route-error.tsx';
import { isTwoFactorRequired, isUnauthorized } from './lib/session.ts';
import { routeTree } from './routeTree.gen.ts';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    // Сеанс завершён (выход на другом устройстве, отключение) — ко входу, с возвратом сюда.
    onError: (error) => {
      // Защиту входа сделали обязательной посреди сеанса — на экран её настройки.
      if (isTwoFactorRequired(error)) {
        if (router.state.location.pathname !== '/secure')
          void router.navigate({ to: '/secure', replace: true });
        return;
      }
      if (!isUnauthorized(error)) return;
      const { pathname, href } = router.state.location;
      if (pathname === '/login' || pathname.startsWith('/invite/')) return;
      void router.navigate({ to: '/login', search: { redirect: href }, replace: true });
    },
  }),
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: true },
  },
});

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  defaultErrorComponent: RouteError,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
